<template>
  <v-card flat>
    <v-card-text>
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        fileNamePrefix="payments"
        identifier="claim_submission_payments"
        :showSelect="false"
      ></pbas-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { InMemoryProvider } from "pbas-vue-components";
import getHeaders from "@/headers/InMemoryPayments";

export default {
  props: [
    "payments",
  ],
  data() {
    return {
      provider: undefined,
    };
  },
  watch: {
    payments: {
      async handler(v) {
        if (v) {
          this.provider = new InMemoryProvider(v, getHeaders());
        }
      },
    },
    immediate: true,
  },
  async mounted() {
    if (this.payments) {
      console.log(this.payments);
      this.provider = new InMemoryProvider(
      this.payments,
      getHeaders()
    );
    }
    
  },
};
</script>
